import React, { useCallback, useEffect, useReducer, useState } from "react";
import { Table, Button, Form, Card, Pagination, Alert } from "react-bootstrap";
import ModalCuentaAdmin from "./modaladmin/ModalCuentaAdmin";
import ModalChangePassword from "./modaladmin/ModalChangePassword";
import Procedimientos from "./Procedimientos";
import Tipo from "./Tipos";
import Swal from "sweetalert2";
import { getlegajosbyliquidacion } from "../../../api/marcacionApi";
import * as XLSX from "xlsx";
import ModalAddMarcacion from "./modaladmin/ModalAddMarcacion";
import ModalAdminActivity from "./modaladmin/ModalAdminActivity";
import { AddLegajo } from "../../../api/marcacionApi";
import {
  insertAdmin,
  updateAdmin,
  getAllAdmin,
  UpdateEstadoAdmin,
  changePasswordAdmin,
  getAdminCredentials,
  getAllOtpLogs,
  revokeAllAdminSessions,
} from "../../../api/AdminApi";
import { getOtpCode } from "../../../api/OtpApi";
import { TiMinus, TiPlus } from "react-icons/ti";

const showReducer = (curShow, state) => {
  switch (state.type) {
    case "SHOW":
      return {
        isShow: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
        item: state.item || null,
      };
    case "END":
      return { ...curShow, isShow: false };
    default:
      return curShow;
  }
};

export const Admin = () => {
  const [admins, setAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [userdata, setUSERDATA] = useState();
  const [isnewAdmin, setIsnewAdmin] = useState(true);
  const [datoAdmin, setDatoAdmin] = useState({});
  const [searchId, setSearchId] = useState("");
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);
  const [otplogs, setOtplogs] = useState([]);
  const [showActivas, setShowActivas] = useState(true);
  const [activityAdmin, setActivityAdmin] = useState(null);

  // OTP por cuenta
  const [generatingOtpFor, setGeneratingOtpFor] = useState(null);

  // Paginación
  const [currentPageAdmins, setCurrentPageAdmins] = useState(1);
  const [currentPageOtp, setCurrentPageOtp] = useState(1);
  const itemsPerPage = 10;

  const [reducer, dispatchReducer] = useReducer(showReducer, {
    isShow: false,
    typeModal: null,
    onReturnValue: null,
    item: null,
  });

  // ===================== VERIFICAR PERMISOS =====================
  useEffect(() => {
    const checkPermissionAndLoad = async () => {
      setLoading(true);
      try {
        const USERDATA = await getAdminCredentials();
        
        if (!USERDATA) {
          setHasPermission(false);
          setLoading(false);
          return;
        }

        if (USERDATA?.IdTipoUsuario !== "0" && USERDATA?.IdTipoUsuario !== "2") {
          setHasPermission(false);
          setLoading(false);
          return;
        }

        setUSERDATA(USERDATA);
        setHasPermission(true);
      } catch (error) {
        console.error("Error verificando permisos:", error);
        setHasPermission(false);
        Swal.fire({
          icon: "error",
          title: "Error de autenticación",
          text: "No se pudo verificar sus permisos. Por favor, inicie sesión nuevamente.",
          confirmButtonText: "Entendido",
        });
      } finally {
        setLoading(false);
      }
    };
    checkPermissionAndLoad();
  }, []);

  useEffect(() => {
    if (hasPermission === true) loadAdmins();
  }, [hasPermission]);

  // ===================== CARGAR DATOS =====================
  const loadAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const [adminResult, otplogsResult] = await Promise.all([
        getAllAdmin(),
        getAllOtpLogs(),
      ]);
      
      setAdmins(adminResult || []);
      setFilteredAdmins(adminResult || []);
      setOtplogs(otplogsResult || []);
    } catch (err) {
      console.error("Error cargando datos:", err);
      Swal.fire({
        icon: "error",
        title: "Error al cargar datos",
        text: "No se pudieron cargar los administradores. Intente nuevamente.",
        confirmButtonText: "Reintentar",
      }).then((result) => {
        if (result.isConfirmed) {
          loadAdmins();
        }
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSearchId = (e) => setSearchId(e.target.value);

  // ===================== EXPORTAR A EXCEL =====================
  const exportToExcel = async () => {
    if (!searchId || searchId.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "ID requerido",
        text: "Por favor ingrese un ID de liquidación válido.",
        confirmButtonText: "Entendido",
      });
      return;
    }

    try {
      Swal.fire({
        title: "Exportando datos...",
        text: "Por favor espere",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const data1 = await getlegajosbyliquidacion(searchId);

      if (!data1 || data1.length === 0) {
        Swal.close();
        Swal.fire({
          icon: "info",
          title: "Sin datos",
          text: `No se encontraron registros para la liquidación ${searchId}.`,
          confirmButtonText: "Entendido",
        });
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(data1);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Liquidacion " + searchId);
      XLSX.writeFile(workbook, `liquidacion_${searchId}.xlsx`);

      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Excel generado",
        text: `Se descargó el archivo de liquidación ${searchId}.`,
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Error exportando:", err);
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error al exportar",
        text: err.message || "No se pudo exportar el archivo. Intente nuevamente.",
        confirmButtonText: "Entendido",
      });
    }
  };

  // ===================== MODALES ADMIN =====================
  const handleShowNewAdmin = () => {
    setDatoAdmin({ cuenta: "", nombrecompleto: "", idadmin: "" });
    setIsnewAdmin(true);
    dispatchReducer({ type: "SHOW", typeModal: "FERIADO" });
  };

  const handleShowEditAdmin = (data) => {
    setDatoAdmin(data);
    setIsnewAdmin(false);
    dispatchReducer({ type: "SHOW", typeModal: "FERIADO" });
  };

  const handleShowChangePassword = (item) => {
    dispatchReducer({
      type: "SHOW",
      typeModal: "CHANGE_PASSWORD",
      item: { idadmin: item.idadmin, cuenta: item.cuenta },
    });
  };

  const handleShowAddMarcacion = () => {
    dispatchReducer({
      type: "SHOW",
      typeModal: "ADD_MARCACION",
    });
  };

  // ===================== GUARDAR MARCACIÓN =====================
  const onReturnMarcacion = async (data) => {
    dispatchReducer({ type: "END" });

    Swal.fire({
      title: "Guardando marcación...",
      text: "Por favor espere",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      await AddLegajo(data);

      Swal.close();
      Swal.fire({
        icon: "success",
        title: "¡Marcación agregada!",
        text: "La marcación se registró correctamente.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Error agregando marcación:", err);
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: err.message || "No se pudo registrar la marcación.",
        confirmButtonText: "Entendido",
      });
    }
  };

  // ===================== GUARDAR DATOS ADMIN =====================
  const onReturnDataAdmin = async (data, isnew, typeModal) => {
    dispatchReducer({ type: "END" });

    Swal.fire({
      title: "Procesando...",
      text: "Por favor espere",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      let result;
      let successMessage = "";

      if (typeModal === "CHANGE_PASSWORD") {
        result = await changePasswordAdmin({
          idadmin: data.idadmin,
          cuenta: data.cuenta,
          newPassword: data.newPassword,
        });
        successMessage = "Contraseña actualizada correctamente";
      } else if (isnew) {
        result = await insertAdmin(data);
        successMessage = "Administrador creado correctamente";
      } else {
        result = await updateAdmin(data);
        successMessage = "Administrador actualizado correctamente";
      }

      Swal.close();

      if (result) {
        Swal.fire({
          icon: "success",
          title: "¡Éxito!",
          text: successMessage,
          timer: 2000,
          showConfirmButton: false,
        });
        loadAdmins();
      } else {
        Swal.fire({
          icon: "warning",
          title: "Advertencia",
          text: "La operación no se completó correctamente.",
          confirmButtonText: "Entendido",
        });
      }
    } catch (err) {
      console.error("Error guardando admin:", err);
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "No se pudo completar la operación.",
        confirmButtonText: "Entendido",
      });
    }
  };

  const onCloseModal = () => dispatchReducer({ type: "END" });

  // ===================== CAMBIAR ESTADO ADMIN =====================
  const EstadoAdmin = async (id) => {
    const adminToUpdate = admins.find((a) => a.idadmin === id);
    const estadoActual = adminToUpdate?.estado || "ACTIVO";
    const nuevoEstado = estadoActual === "ACTIVO" ? "INACTIVO" : "ACTIVO";

    const result = await Swal.fire({
      title: "¿Cambiar estado?",
      html: `¿Desea cambiar el estado a <strong>${nuevoEstado}</strong>?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });

    if (result.isConfirmed) {
      try {
        Swal.fire({
          title: "Actualizando estado...",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        await UpdateEstadoAdmin(id, nuevoEstado);

        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Estado actualizado",
          text: `El estado cambió a ${nuevoEstado}`,
          timer: 1500,
          showConfirmButton: false,
        });
        
        loadAdmins();
      } catch (err) {
        console.error("Error cambiando estado:", err);
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cambiar el estado.",
          confirmButtonText: "Entendido",
        });
      }
    }
  };

  const cerrarSesionesAdmin = async (item) => {
    const result = await Swal.fire({
      title: "¿Cerrar todas las sesiones?",
      text: `${item.cuenta} perderá acceso en todos sus dispositivos.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cerrar sesiones",
      cancelButtonText: "Cancelar",
    });
    if (!result.isConfirmed) return;
    try {
      const response = await revokeAllAdminSessions(item.idadmin);
      await loadAdmins();
      Swal.fire({
        icon: "success",
        title: "Sesiones cerradas",
        text: `Se cerraron ${response.revoked || 0} sesiones.`,
        timer: 1600,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire("Error", error.message || "No se pudieron cerrar las sesiones.", "error");
    }
  };

  const isButtonDisabled = (item) => {
    if (userdata?.IdTipoUsuario === "2") return false;
    if (userdata?.IdTipoUsuario === "0") return item.IdTipoUsuario === "2";
    return true;
  };

  // ===================== OTP POR CUENTA =====================
  const generarCodigoCuenta = async (item) => {
    if (!item?.cuenta) {
      Swal.fire({
        icon: "warning",
        title: "Cuenta no válida",
        text: "No se pudo identificar la cuenta para generar el OTP.",
      });
      return;
    }

    setGeneratingOtpFor(item.idadmin);

    try {
      const data = await getOtpCode(item.cuenta);
      const ttl = data.ttl || data.expiraEn || 30;

      const result = await Swal.fire({
        icon: "success",
        title: "Código OTP generado",
        html: `
          <div class="text-start">
            <p class="mb-2">Cuenta: <strong>${item.cuenta}</strong></p>
            <div class="alert alert-info text-center mb-2">
              <div class="fs-4 fw-bold">${data.codigo}</div>
              <small>Expira en ${ttl} segundos</small>
            </div>
            <small class="text-muted">Este código solo podrá usarlo la cuenta indicada.</small>
          </div>
        `,
        confirmButtonText: "Copiar código",
        showCancelButton: true,
        cancelButtonText: "Cerrar",
      });

      if (result.isConfirmed && data.codigo && navigator?.clipboard) {
        await navigator.clipboard.writeText(String(data.codigo));
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Código copiado al portapapeles",
          showConfirmButton: false,
          timer: 1200,
        });
      }

      loadAdmins();
    } catch (err) {
      console.error("Error generando OTP:", err);
      Swal.fire({
        icon: "error",
        title: "Error al generar código",
        text: err.message || "No se pudo generar el código OTP.",
        confirmButtonText: "Entendido",
      });
    } finally {
      setGeneratingOtpFor(null);
    }
  };

  // ===================== PAGINACIÓN =====================
  const paginate = (data, currentPage) =>
    data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const adminsPage = paginate(filteredAdmins, currentPageAdmins);
  const otpPage = paginate(otplogs, currentPageOtp);

  const renderPagination = (total, current, setPage) => {
    const totalPages = Math.ceil(total / itemsPerPage);
    if (totalPages <= 1) return null;

    const pages = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, current - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    if (startPage > 1) {
      pages.push(
        <Pagination.First key="first" onClick={() => setPage(1)} />
      );
      pages.push(
        <Pagination.Prev key="prev" onClick={() => setPage(current - 1)} disabled={current === 1} />
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Pagination.Item key={i} active={i === current} onClick={() => setPage(i)}>
          {i}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      pages.push(
        <Pagination.Next key="next" onClick={() => setPage(current + 1)} disabled={current === totalPages} />
      );
      pages.push(
        <Pagination.Last key="last" onClick={() => setPage(totalPages)} />
      );
    }

    return <Pagination className="justify-content-center mt-2 mb-0">{pages}</Pagination>;
  };

  // ===================== ESTILOS =====================
  const btnIconStyle = {
    width: 30,
    height: 30,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 6,
  };

  // ===================== RENDERIZADO CONDICIONAL =====================
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
            <span className="visually-hidden">Cargando...</span>
          </div>
          <p className="mt-3 text-muted">Cargando información...</p>
        </div>
      </div>
    );
  }

  if (hasPermission === false) {
    return (
      <div className="container mt-5">
        <Alert variant="danger" className="text-center">
          <Alert.Heading>
            <i className="fas fa-exclamation-triangle me-2"></i>
            Acceso Denegado
          </Alert.Heading>
          <p className="mb-0">
            No tiene permisos suficientes para acceder a esta sección.
            <br />
            Por favor, contacte al administrador del sistema.
          </p>
        </Alert>
      </div>
    );
  }

  // ===================== RENDER PRINCIPAL =====================
  return (
    <div className="container-fluid">
      <div className="row gy-4">
        {/* BOTÓN MARCACIÓN */}
        <div className="col-12">
          <Button
            variant="success"
            size="sm"
            onClick={handleShowAddMarcacion}
          >
            ➕ Nueva Marcación
          </Button>
        </div>

        {/* ADMIN */}
        <div className="col-12">
          <Card className="shadow-sm">
            <Card.Header className="d-flex justify-content-between align-items-center bg-primary-subtle">
              <h5 className="mb-0">👥 Cuentas Administrativas</h5>
              <Button variant="primary" size="sm" onClick={handleShowNewAdmin}>
                <i className="fas fa-plus me-1"></i>
                Agregar
              </Button>
            </Card.Header>
            <Card.Body className="p-0">
              {adminsPage.length === 0 ? (
                <Alert variant="info" className="m-3 text-center">
                  No hay administradores registrados
                </Alert>
              ) : (
                <>
                  <Table responsive  className="mb-0 text-center align-middle table-sm">
                    <thead>
                      <tr>
                        <th style={{ width: "60px" }}>#</th>
                        <th>Cuenta</th>
                        <th>Nombre</th>
                        <th style={{ width: "100px" }}>Estado</th>
                        <th style={{ width: "220px" }}>Sesión</th>
                        <th style={{ width: "240px" }}>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {adminsPage.map((item, i) => (
                        <tr key={item.idadmin || i}>
                          <td>{item.idadmin}</td>
                          <td>{item.cuenta}</td>
                          <td>{item.nombrecompleto}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.estado === "INACTIVO"
                                  ? "bg-danger"
                                  : "bg-success"
                              }`}
                            >
                              {item.estado}
                            </span>
                          </td>
                          <td>
                            <span className={`badge ${Number(item.active_sessions) > 0 ? "bg-success" : "bg-secondary"}`}>
                              {Number(item.active_sessions) > 0 ? `${item.active_sessions} en línea` : "Desconectado"}
                            </span>
                            {(item.active_since || item.last_login_at) && (
                              <small className="d-block text-muted mt-1">
                                {Number(item.active_sessions) > 0 ? "Desde: " : "Último: "}
                                {new Date(String(item.active_since || item.last_login_at).replace(" ", "T")).toLocaleString("es-PY", { dateStyle: "short", timeStyle: "short" })}
                              </small>
                            )}
                          </td>
                          <td>
                            <div className="d-flex justify-content-center gap-2">
                              <Button
                                size="sm"
                                variant="outline-danger"
                                style={btnIconStyle}
                                disabled={isButtonDisabled(item) || Number(item.active_sessions) === 0}
                                onClick={() => cerrarSesionesAdmin(item)}
                                title="Cerrar todas las sesiones"
                              >
                                <i className="fas fa-sign-out-alt fa-sm"></i>
                              </Button>
                              <Button
                                size="sm"
                                variant="outline-secondary"
                                style={btnIconStyle}
                                onClick={() => setActivityAdmin(item)}
                                title="Ver sesiones y actividad"
                              >
                                <i className="fas fa-history fa-sm"></i>
                              </Button>
                              <Button
                                size="sm"
                                variant="outline-primary"
                                style={btnIconStyle}
                                disabled={isButtonDisabled(item)}
                                onClick={() => handleShowEditAdmin(item)}
                                title="Editar"
                              >
                                <i className="fas fa-pen fa-sm"></i>
                              </Button>
                              <Button
                                size="sm"
                                variant="outline-warning"
                                style={btnIconStyle}
                                disabled={isButtonDisabled(item)}
                                onClick={() => handleShowChangePassword(item)}
                                title="Cambiar contraseña"
                              >
                                <i className="fas fa-key fa-sm"></i>
                              </Button>
                              <Button
                                size="sm"
                                variant="outline-info"
                                style={btnIconStyle}
                                disabled={isButtonDisabled(item) || generatingOtpFor === item.idadmin}
                                onClick={() => generarCodigoCuenta(item)}
                                title="Generar OTP para esta cuenta"
                              >
                                {generatingOtpFor === item.idadmin ? (
                                  <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                  <i className="fas fa-shield-alt fa-sm"></i>
                                )}
                              </Button>
                              <Button
                                size="sm"
                                variant="outline-danger"
                                style={btnIconStyle}
                                disabled={isButtonDisabled(item)}
                                onClick={() => EstadoAdmin(item.idadmin)}
                                title={
                                  item.estado === "INACTIVO"
                                    ? "Activar"
                                    : "Desactivar"
                                }
                              >
                                <i
                                  className={
                                    item.estado === "INACTIVO"
                                      ? "fas fa-undo fa-sm"
                                      : "fas fa-trash fa-sm"
                                  }
                                ></i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {renderPagination(filteredAdmins.length, currentPageAdmins, setCurrentPageAdmins)}
                </>
              )}
            </Card.Body>
          </Card>
        </div>

        {/* EXPORTAR */}
        <div className="col-xl-5 col-lg-6">
          <Card className="shadow-sm">
            <Card.Header className="bg-success-subtle">
              <h5 className="mb-0">📤 Exportar Liquidaciones</h5>
            </Card.Header>
            <Card.Body>
              <Form.Group>
                <Form.Label>ID Liquidación</Form.Label>
                <Form.Control
                  type="text"
                  value={searchId}
                  onChange={handleSearchId}
                  placeholder="Ingrese el ID de liquidación"
                />
              </Form.Group>
              <Button
                variant="success"
                className="mt-3 w-100"
                onClick={exportToExcel}
                disabled={!searchId}
              >
                <i className="fas fa-file-excel me-2"></i>
                Descargar Excel
              </Button>
            </Card.Body>
          </Card>
        </div>

        {/* OTP LOGS */}
        <div className="col-12">
          <Card className="shadow-sm">
            <Card.Header className="bg-info-subtle">
              <h5 className="mb-0">📜 Historial de Códigos OTP</h5>
            </Card.Header>
            <Card.Body className="p-0">
              {otpPage.length === 0 ? (
                <Alert variant="info" className="m-3 text-center">
                  Sin registros de códigos OTP
                </Alert>
              ) : (
                <>
                  <Table responsive  className="mb-0 text-center align-middle table-sm">
                    <thead>
                      <tr>
                        <th style={{ width: "60px" }}>#</th>
                        <th>Usuario</th>
                        <th>Código</th>
                        <th>Estado</th>
                        <th>ID Referencia</th>
                        <th>Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      {otpPage.map((log, idx) => (
                        <tr key={idx}>
                          <td>{(currentPageOtp - 1) * itemsPerPage + idx + 1}</td>
                          <td>{log.Usuario}</td>
                          <td>
                            <code>{log.codigo}</code>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                log.accion === "USADO" || log.accion === "Usado"
                                  ? "bg-success"
                                  : "bg-secondary"
                              }`}
                            >
                              {log.accion}
                            </span>
                          </td>
                          <td>{log.idReferencia}</td>
                          <td>{log.fechaUso}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {renderPagination(otplogs.length, currentPageOtp, setCurrentPageOtp)}
                </>
              )}
            </Card.Body>
          </Card>
        </div>

        {/* ASISTENCIA */}
        <div className="col-12">
          <Card className="shadow-sm">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">📋 Asistencia</h5>
              <i
                onClick={() => setShowActivas(!showActivas)}
                style={{ cursor: "pointer", fontSize: "1.5rem" }}
                title={showActivas ? "Ocultar" : "Mostrar"}
              >
                {showActivas ? <TiMinus /> : <TiPlus />}
              </i>
            </Card.Header>
            {showActivas && (
              <Card.Body>
                <div className="row">
                  <div className="col-lg-6 mb-3 mb-lg-0">
                    <Procedimientos />
                  </div>
                  <div className="col-lg-6">
                    <Tipo />
                  </div>
                </div>
              </Card.Body>
            )}
          </Card>
        </div>
      </div>

      {/* MODALES */}
      {reducer.isShow && reducer.typeModal === "FERIADO" && (
        <ModalCuentaAdmin
          estado={reducer.isShow}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnDataAdmin}
          item={datoAdmin}
          isnew={isnewAdmin}
        />
      )}
      {reducer.isShow && reducer.typeModal === "CHANGE_PASSWORD" && (
        <ModalChangePassword
          estado={reducer.isShow}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnDataAdmin}
          item={reducer.item}
        />
      )}
      {reducer.isShow && reducer.typeModal === "ADD_MARCACION" && (
        <ModalAddMarcacion
          estado={reducer.isShow}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnMarcacion}
        />
      )}
      <ModalAdminActivity
        show={Boolean(activityAdmin)}
        admin={activityAdmin}
        onHide={() => setActivityAdmin(null)}
        onChanged={loadAdmins}
      />
    </div>
  );
};

export default Admin;
